"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18n = i18n;
exports.addBundle = addBundle;
exports.getLocale = getLocale;
exports.getLanguages = getLanguages;
exports.setLocale = setLocale;
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _I18n["default"];
  }
});
exports.localize = exports.contextualize = exports.I18nContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _reactI18nifyLite = require("@ifly/react-i18nify-lite");

var _I18n = _interopRequireDefault(require("./components/I18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// cookie options
var COOKIE_OPTS = {
  expires: 30,
  domain: 'iflyworld.com',
  secure: true,
  samesite: 'strict'
}; /// Immediately recover any existing locale or default to 'en'.

var locale = getLocale();
setLocale(locale); /// Immediately set the fall-back translation handler.

_reactI18nifyLite.I18n.setHandleMissingTranslation(function (key, replacements) {
  if (_reactI18nifyLite.I18n._locale !== 'en') {
    // resolve the missing key from the default locale
    try {
      // NOTE: See module '@ifly/react-i18nify-lite' :: I18n->_translate 
      replacements = replacements || {};

      var translation = _reactI18nifyLite.I18n._fetchTranslation(_reactI18nifyLite.I18n._translations, "en.".concat(key), replacements.count);

      return _reactI18nifyLite.I18n._replace(translation, replacements);
    } catch (err) {
      return key;
    }
  }

  return key; // default locale did not contain the key
}); /// The resources merged from all added bundles.


var mergedMessages = {}; /// Maps added bundle name to its translations. 

var bundledMessages = {};
/**
 * Helper returns the given language tag if in the short format `pt` or in the
 * long format `pt-BR`; otherwise returns the default locale `en`.
 *
 * https://en.wikipedia.org/wiki/Language_localisation#Language_tags_and_codes
 *
 * @param tag The desired language tag.
 * @returns A language tag for a defined language bundle.
 */

function defaultLocale(tag) {
  return /^[a-z]{2}(-[A-Z]{2})?$/.test(tag) ? tag : 'en';
}
/**
 * Helper recursively merges a new language bundle with any existing bundles.
 * @param name The new bundle name.
 * @param o1 The current bundle.
 * @param o2 The new bundle.
 * @param keyprefix The current key space being resolved (for debug).
 */


function bundleMerge(name, o1, o2, keyprefix) {
  var result = _objectSpread({}, o1);

  for (var key in o2) {
    var v1 = o1[key],
        v2 = o2[key],
        isV2str = v2 && 'string' === typeof v2;

    if (!v1) {
      result[key] = isV2str ? v2 : _objectSpread({}, v2); // populate new key
    } else {
      var isV1str = 'string' === typeof v1;

      if (isV1str && isV2str) {
        result[key] = v2; // overwrite string with string
      } else {
        var prefix = (keyprefix ? keyprefix + '.' : '') + key;

        if (!isV1str && isV2str) {
          // overwrite object with string (warning)
          console.warn("ifly-i18n -- addBundle(".concat(name, ") -- Overwrote group \"").concat(prefix, "\" with single resource value of \"").concat(v2, "\"."));
          result[key] = v2;
        } else if (isV1str && !isV2str) {
          // overwrite string with object (warning)
          console.warn("ifly-i18n -- addBundle(".concat(name, ") -- Overwrote single resource \"").concat(prefix, "\" value of \"").concat(v1, "\" with group."));
          result[key] = _objectSpread({}, v2);
        } else {
          // recursively resolve the nested resources
          result[key] = bundleMerge(name, v1, v2, prefix);
        }
      }
    }
  }

  return result;
} /// The I18nContext publishes the current locale and a function to update the locale.


var I18nContext = _react["default"].createContext({
  locale: locale,
  setLocale: setLocale
});
/**
 * Wraps a component (or the entire App) in an I18nContext.Provider
 * Also manages the locale state internally.
 * 
 * @param {*} WrappedComponent 
 */


exports.I18nContext = I18nContext;

var contextualize = function contextualize(WrappedComponent) {
  var _temp;

  return _temp =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(_temp, _React$Component);

    function _temp() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, _temp);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_temp)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _this.setLocale = function (locale) {
        setLocale(locale);

        _this.setState({
          locale: locale,
          setLocale: _this.setLocale
        });
      };

      _this.state = {
        locale: getLocale(),
        setLocale: _this.setLocale
      };
      return _this;
    }

    _createClass(_temp, [{
      key: "render",
      value: function render() {
        return _react["default"].createElement(I18nContext.Provider, {
          value: this.state
        }, _react["default"].createElement(WrappedComponent, this.props));
      }
    }]);

    return _temp;
  }(_react["default"].Component), _temp;
}; /// Wraps the component with a I18nContext.Consumer passing `locale` and `setLocale` as
/// props. The wrapped component will automatically re-render when the locale changes,
/// and may update the locale with the setLocale function.


exports.contextualize = contextualize;

var localize = function localize(WrappedComponent) {
  return function i18n$localize(props) {
    return _react["default"].createElement(I18nContext.Consumer, null, function (contextValue) {
      return _react["default"].createElement(WrappedComponent, _extends({}, props, contextValue));
    });
  };
};
/**
 * Resolves the message for the given key replacing any tokens with the given map of data.
 * 
 * NOTE: Messages returned from this function do not update when the locale changes. It
 *       is recommended that you use the <I18n $="some.message"/> tag where possible.
 *
 * This i18n function is useful for populating attributes of native dom elements (alt, title,
 * placeholder, etc.) where using the tag above cryptically emits the string [object Object].
 * 
 * To use this i18n function in your component wrap your component with the localize function
 * above then add an <I18nContext.Provider value={this.state.locale}> near your application's
 * root.
 * 
 * The localize function wraps a <I18nContext.Consumer> around your component and forces your
 * component to re-render when the I18nContext provider value changes.
 * 
 * The <I18n> component automatically re-renders on locale change there is no need to wrap
 * your component if it only uses <I18n> components to resolve messages.
 * 
 * @param key The message resource key.
 * @param replacements (optional) Map of tokens to replace.
 * @return An internationalized message.
 */


exports.localize = localize;

function i18n(key, replacements) {
  return _reactI18nifyLite.I18n.t(key, replacements);
}
/**
 * Adds the given translations to the resource bundle merging with any existing translations.
 * @param name The unique bundle name. For example, the project's name or related domain name.
 * @param translations A simple object of translations keyed at the top-level by language tag.
 */


function addBundle(name, translations) {
  bundledMessages[name] = translations;
  mergedMessages = bundleMerge(name, mergedMessages, translations);

  _reactI18nifyLite.I18n.setTranslations(mergedMessages);
}
/**
 * Gets the language code persisted in a cookie or the default locale.
 * @return An internationalized message.
 */


function getLocale() {
  return defaultLocale(_jsCookie["default"].get('ifly_current_language'));
}
/**
 * Gets the languages that have been added to the translations bundle.
 * @return An array of the languages represented in the message resources.
 */


function getLanguages() {
  var translations = _reactI18nifyLite.I18n._translations,
      langs = [];

  for (var lang in translations) {
    langs.push(_objectSpread({}, translations[lang].$));
  }

  langs.sort(function (a, b) {
    return a.name - b.name;
  });
  return langs;
}
/**
 * Set the i18n locale bundle and saves the language code in a cookie.
 * @param {String} lang The language code.
 */


function setLocale(lang) {
  var code = defaultLocale(lang || 'en');

  _reactI18nifyLite.I18n.setLocale(code);

  _jsCookie["default"].set('ifly_current_language', code, COOKIE_OPTS); // console.log('Set language ('+ lang +') to cookie: ', code);

}